import * as React from "react";

import TextInputAnt from "./TextInputAnt";

import { Form, Input, Radio } from "antd";
import { Plus, Trash2 } from "lucide-react";

import { Button } from "src/components/buttons";
import { Icon } from "src/components/icons/Icon";

interface IProps {
	value: CustomFieldOptionsData[];
	onAdd: () => void;
	onChange?: (event: any) => void;
	onStatusChange?: (event: any) => void;
	onRemove: (id: number) => void;
	validation?: any;
}

const CustomFieldOptions: React.FC<IProps> = (props) => {
	return (
		<React.Fragment>
			<label>Options</label>
			<div className="border px-4 pt-4 pb-4">
				<div className="row">
					{props.value!.map((val, index) => {
						var mainIndex = index;
						return (
							<div className="col-3" key={index}>
								<div>
									<Form.Item>
										<div className="row">
											<Input.Group>
												<TextInputAnt
													id={index.toString()}
													key={index}
													value={val.options}
													onChange={props.onChange}
													focus={
														index === props.value.length - 1 ? true : false
													}
												/>
												<Button
													className="btn-outline-primary"
													onClick={() => props.onRemove(index)}
												>
													<Icon icon={Trash2} />
												</Button>
											</Input.Group>
										</div>
									</Form.Item>
								</div>
								<div>
									<Form.Item
										validateStatus={
											val.options === undefined || val.options === ""
												? "error"
												: "success"
										}
										help={
											val.options === undefined || val.options === ""
												? "Please enter an option"
												: ""
										}
										hasFeedback={true}
										key={index}
									>
										<Radio.Group
											id={index.toString()}
											value={val.active}
											key={index}
											name="active"
											onChange={props.onStatusChange}
										>
											{[
												{ label: "Active", value: true },
												{ label: "InActive", value: false },
											].map((item, index) => {
												return (
													<Radio
														id={mainIndex.toString()}
														key={index}
														value={item.value}
													>
														{item.label}
													</Radio>
												);
											})}
										</Radio.Group>
									</Form.Item>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			<Button className="btn-outline-primary mt-3" onClick={props.onAdd}>
				Add Option <Icon icon={Plus} className="ml-1" />
			</Button>
		</React.Fragment>
	);
};

export default CustomFieldOptions;
